import { gql } from '@apollo/client';
import client from '../../../../core/services/graphql';

export const GET_TEST_SESSIONS = gql`
  query TestSessionsApprovalsTab(
    $status: TestSessionStatusEnum,
    $projectId: ID!,
    $limit: Int,
  ) {
    testSessionsApprovalsTab(
      status: $status,
      projectId: $projectId,
      limit: $limit,
    ) {
      id
      approved
      removed
      tester {
        id
        removedReason
        userInterviewsPayStatus
        userInterviewsStatus
        userInterviewsParticipantId
        screenerSession {
          id
        }
        segment {
          name
          createdAt
        }
        user {
          id
          tester
          profile {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const SEND_TO_NLP = gql`
  mutation NLP($projectId: ID!) {
    nlp(projectId: $projectId) {
      projectId
    }
  }
`;

export const UPDATE_VIDEO = gql`
  mutation UpdateVideo($testSessionId: ID!, $newVideoName: String!) {
    updateVideo(testSessionId: $testSessionId, name: $newVideoName) {
      testSession {
        id
      }
    }
  }
`;

export const updateVideo = async (testSessionId, newVideoName) => {
  const { data } = await client.getClient().mutate({
    mutation: UPDATE_VIDEO,
    variables: { testSessionId, newVideoName },
  });

  return data;
};

export const removeTestSession = async (id, removed) => {
  const mutation = gql`
    mutation RemoveTestSession($id: ID!, $removed: Boolean!) {
      removeTestSession(id: $id, removed: $removed) {
        testSession {
          id
        }
      }
    }
  `;

  const { data } = await client.getClient().mutate({
    mutation,
    variables: { id, removed },
    refetchQueries: ['TestSessions'],
  });

  return data;
};

export const approveTestSession = async (id, approved) => {
  const mutation = gql`
    mutation ApproveTestSession($id: ID!, $approved: Boolean!){
      approveTestSession(id: $id, approved: $approved) {
        testSession {
          id
        }
      }
    }
  `;

  const { data } = await client.getClient().mutate({
    mutation,
    variables: { id, approved },
    refetchQueries: ['TestSessions'],
  });

  return data;
};
